import React from 'react'

const Careeropportunities = () => {
  return (
    <div>
      <div>
        <h3>Working with words</h3>
        <p className='question'>A. Complete the sentences with the correct words from the box below.</p>
        <p>a. You must learn about 2000 Kanji to develop <strong>competence</strong> in spoken Japanese language.</p>
        <p>b. I can try both English and Nepali but not as fast as <strong>professional</strong> typists.</p>
        <p>c. When she was in class eight, she got the <strong>opportunity</strong> to participate in a national painting competition.</p>
        <p>d. The Prime Minister gave a long list of his <strong>achievements.</strong></p>
        <p>e. He spent many years in jail before reaching the <strong>position </strong>of a minister.</p>
        <p>f. About fifty workers were made <strong>redundant</strong> because of the financial crisis in the factory.</p>
        <p>g. He is affiliated to the World Bank as a senior <strong>consultant.</strong>
        </p>
        <p>h. They registered my application after making <strong>verification </strong> of my documents.</p>
        <p>i. I requested my teacher to be my <strong>referee</strong> in my CV.</p>
        <p>j. To make our country self-sustained in food production is <strong>imperative </strong>need at present.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>Define the following employment-related terms and use them in the sentences of your own.</p>
        <p> <strong>volunteering:</strong> Volunteering: doing unpaid work, often to help a community or cause.</p><p>
Volunteering offers a great opportunity to gain experience while making a positive impact.</p>
<br/>
<p><strong>on the job training:</strong> training that takes place while a person is doing the actual job.</p>
<p>On-the-job training helps employees learn practical skills directly in the work environment.</p>
<br/>
<p><strong>career opportunity:</strong> a chance to start or advance in a job or profession.</p>
<p>Joining the tech company gave her a great career opportunity to grow as a software developer.</p>
<br/>
<p><strong>skill development:</strong> the process of improving abilities through training, practice, or experience.</p>
<p>Skill development is essential for staying competitive in today's fast-changing job market.</p>
<br/>
<p><strong>apprenticeship: </strong>a system of training where a person learns a trade or skill by working under a skilled worker.</p>
<p>He joined an apprenticeship program to become a certified electrician.</p>
<br/>
<p><strong>career counselling: </strong>professional advice and guidance given to individuals to help them choose or develop their career path.</p>
<p>She went for career counselling to explore the best options after completing high school.</p>
<br/>
<p><strong>credentials: </strong>qualifications, achievements, or experiences that prove someone's ability or suitability for a job or task.</p>
<p>She presented her academic credentials during the job interview to demonstrate her expertise.</p>
<br/>
<p><strong>human capital: </strong>the skills, knowledge, and experience possessed by an individual or workforce, viewed as valuable assets to an organization.</p>
<p>Investing in employee training is essential to improve a company's human capital.</p>
<br/>
<p><strong>internship: </strong>a temporary position where a student or trainee works to gain practical experience in a particular field.</p>
<p>She completed a summer internship at a law firm to gain hands-on experience.</p>
<br/>
<p><strong>soft skills: </strong>personal attributes like communication, teamwork, and problem-solving that help people interact effectively at work.</p>
<p>Good soft skills are just as important as technical knowledge in most jobs.</p>
<br/>
<p><strong>minimum wage: </strong> the lowest legal amount that employers must pay workers for their labor.</p>
<p>The government raised the minimum wage to ensure workers earn a fair living.</p>
<br/>
<p><strong>recruitment: </strong>the process of finding and hiring suitable candidates for jobs.</p>
<p>The company started recruitment to fill several new positions in the marketing team.</p>
<br/>
<p><strong>role model: </strong>a person whose behavior, example, or success is admired and emulated by others.</p>
<p>She is a great role model for young students because of her dedication and kindness.</p>
<br/>
<p><strong>aptitude: </strong>a natural ability or talent to do something well.</p>
<p>He has a strong aptitude for mathematics, which helped him excel in engineering.</p>
<br/>
<p><strong>assessment: </strong>the process of evaluating or measuring someone's skills, knowledge, or performance.</p>
<p>The company conducted an assessment to find the best candidate for the job.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>C. Based on their pronunciation, divide the following words into two groups so that the vowel sounds rhyme with here and hare.</p>
        <strong>Here</strong>
        <p>fear, beer, heir, ear, leer, cheer, sheer, shear,  mere, deer, dear, clear, sneer, gear</p>
        <p><strong>Hare</strong></p>
        <p>fare, fair, bear, care, air, share, lair, chair, tear (v.), mare, dare, snare</p>
      </div>
      
      <div>
        <hr/>
        <h3>Comprehensioin</h3>
        <p className='question'>Answer the following</p>
        <p className='question'>a. What does a CV mean and why is it important in one's career?</p>
        <p>= A CV is a document that shows your personal details, education, work experience, skills, and achievements related to your career.
</p><p>
A CV is very important because it helps you present yourself professionally when applying for a job, promotion, scholarship, or research funding. It is a way to highlight your strengths and show employers or organizations why you are the right person for the opportunity. A well-prepared CV also allows you to reflect on your progress and plan your future career goals.</p>
        <p className='question'>b. Does the same CV work for all job opportunities? Why or why not?</p>
        <p>= No, the same CV does not work for all job opportunities. While the basic information like your name, education, and experience stays the same, it is better to make small changes to match each specific job. Every job has different requirements, so you should highlight the skills, qualifications, and experience that are most relevant to the position you are applying for.</p>
        <p className='question'>c. What are the different area where CV can help you?</p>
        <p>= A good CV is important in many areas of a professional career. It is needed when applying for jobs, seeking promotions, or trying to get research funding. A CV is also useful when you are asked to be an external examiner for a course or a research thesis. It helps during audits of teaching and research activities, and when a faculty or department must be reviewed by an outside professional organization. In short, a CV is required whenever someone needs to assess your professional skills and experience, either as an individual or as part of a group. It is an important document that shows your competence and achievements in various professional situations.</p>
        <p className='question'>d. What do you mean by 'staying CV' and 'leaving CV'? Which one would you develop for yourself as a freshman?</p>
        <p>= 'Staying CV' refers to a CV that shows you are a good university citizen. It includes activities like committee work, helping and caring for students, teaching many courses, and having a steady research record. It shows you are committed to your current institution. On the other hand, a 'leaving CV' is designed to attract a new employer. It focuses more on your research achievements but still shows that you are capable and willing to do all the duties expected of an academic. As a freshman, I would develop a leaving CV because it highlights my strengths and interests that could help me find new opportunities in the future.</p>
        <p className='question'>e. How can you draft a good CV?</p>
        <p>= To draft a good CV, you can start by using a basic framework to organize your information, such as your education, work experience, skills, and achievements. It helps to ask for advice and feedback from friends, family, mentors, or experienced colleagues who know you well or understand what a good CV should look like. By sharing your draft with them, you can get useful suggestions to improve it. This process of organizing your details and receiving feedback will help you create a strong and effective CV.</p>
        <p className='question'>f. What is the difference between academic CV and non-academic CV.</p>
        <p>= The main differences between an academic CV and a non-academic CV are length and content. Academic CVs are usually much longer because they include detailed information about teaching, research, publications, and professional activities. They also tend to grow as the person's career advances. On the other hand, non-academic CVs are shorter and often focus more on personal qualities and skills, some of which may be hard to verify. Especially for middle management jobs, non-academic CVs highlight strengths that may not always be backed by clear evidence, while academic CVs emphasize verifiable achievements.</p>
      </div>
      <div>
        <hr/>
        <h3>Critical thinking</h3>
        <p className='question'>a. CV may not represent a person's skills and abilities accurately because one's confidence can't be rendered in a paper. What do you think the employers should do to find the best people for the job?</p>
        <p>= It is true that a CV may not fully show a person's skills and confidence because these qualities cannot be captured on paper. Employers often look for candidates who can communicate well, both in speaking and writing, as this skill is important in almost every job. In my opinion, instead of only judging people by their CVs, employers should use a three-step selection process. First, they should introduce the company's rules and work conditions to all interested candidates. Those who feel comfortable with these conditions can move to the next step. Second, employers should review the candidates' cover letters to understand their behavior, skills, and character, and decide if they would fit well in the company. Finally, selected candidates should be invited to join a casual group meeting, like a Friday lunch with current employees, where everyone talks about work. Since teamwork is important, current employees should also get a chance to meet and decide if they can work well with the new person. By using these steps, employers can find the best people for the job, rather than relying only on the CV.</p>
        <br/>
        <p className='question'>b. If the employers provide job opportunity by assessing one's CV, how can fresh graduates compete with the experienced competitors?</p>
        <p>= In today's competitive job market, just having a degree and good grades is often not enough to get the job you want. Fresh graduates need to stand out and make a strong impression on employers to compete with experienced candidates. While some jobs require specific degrees, many employers look for more than just exam results. They want candidates with the right personality and important soft skills, like teamwork, communication, and leadership.
</p><p>
Many fresh graduates struggle with writing a good CV because they use common templates and end up with similar-looking resumes. To compete with experienced applicants, fresh graduates should try to be creative and make their CVs unique. For example, if applying for jobs in creative fields, they can design a CV that is visually impressive and different from others. By doing this and highlighting their skills and qualities, fresh graduates can improve their chances and successfully compete against more experienced candidates.</p>
      </div>
      <div>
        <hr/>
        <h3>Writing</h3>
        <p className='question'>Study the following advertisement. Write an application for one of the positions. Prepare your CV too that suits for the job.</p>
        <p> <strong>Job Application Letter</strong> </p><p>
July 2, 2025</p><p>

To,</p><p>
The Hiring Manager</p><p>
Himalayan Coders Organization</p><p>
Kathmandu, Nepal</p><p>
</p> <p>    </p><p>
Subject: Application for the Position of Front-End Developer
</p><p>    </p><p>
Dear Sir/Madam,
</p><p>   </p><p>
I am writing to express my interest in the Front-End Developer position at Himalayan Coders. I have recently completed my Bachelor's degree in Computer Science and Information Technology (CSIT) from Birendra Multiple Campus. During my studies, I have gained strong skills in HTML, CSS, React.js, and working with APIs.
</p><p>
I am passionate about creating user-friendly and visually appealing websites and applications. I enjoy solving problems and continuously learning new technologies to improve my coding skills. I believe my technical knowledge and enthusiasm make me a good fit for your team.
</p><p>
I have attached my CV for your consideration. I would be grateful for the opportunity to discuss how I can contribute to Himalayan Coders.
</p><p>
Thank you for considering my application. I look forward to your positive response.
</p><p>
Sincerely,</p><p>
Priti Acharya
</p>
<br/>
 <p> <strong>Curriculum Vitae (CV)</strong></p><p>
Pairabi Acharya</p><p>
Pokhara, Nepal</p><p>
Email: pairabipaudel@gmail.com</p><p>
Phone: 9899341550</p><p>          </p><p>

Objective</p><p>
To work as a Front-End Developer at Himalayan Coders where I can use my skills in HTML, CSS, React, and APIs to build engaging and efficient web applications, and continue learning in a professional environment.
</p><p>
Education</p><p>
Bachelor of Computer Science and Information Technology (CSIT)</p><p>
Birendra Multiple Campus, Bharatpur</p><p>
Completed: 2025</p>

<strong>Technical Skills </strong><p>
Languages: HTML5, CSS3, JavaScript </p>
<p>
Frameworks/Libraries: React.js
</p><p>
Tools: Git, VS Code</p><p>

APIs: Fetch API, RESTful APIs</p><p>

Others: Responsive Design, Cross-browser Compatibility, Debugging</p><p>

<strong>Projects </strong></p><p>
Personal Portfolio Website</p><p>
Built a responsive portfolio site using React, showcasing my projects and skills.
</p><p>
Weather App</p><p>
Developed a React app that fetches weather data from an API and displays it with dynamic styling.
</p><p>
Personal Qualities</p><p>
Quick learner and enthusiastic about new technologies
</p><p>
Good team player and effective communicator
</p><p>
Detail-oriented and problem solver
</p><p>
References</p><p>
Available on request.
</p>
      </div>
      <div>
        <hr/>
        <h3>Grammar</h3>
        <p className='question'>B. Rewrite the following sentences using the correct form of the verbs.</p>
        <p>a. If you sell your stocks now, you <strong>won't get</strong> much money for them. (not/get)</p>
        <p>b. A lot of people would lose job if the factory <strong>closed down. </strong>(close down)</p>
        <p>c. Our country won't have to export wheat if it <strong>rains</strong> in November and February. (rain)</p>
        <p>d. If we <strong>had found </strong> him earlier, we could have saved his life. (find)</p>
        <p>e. If he had not been wearing helmet, he <strong> would have been</strong> seriously injured. (be)</p>
        <p>f. Unless you follow the instructions, you <strong>won't pass</strong>pass the exams.(not/pass)</p>
        <p>g. I don't mind walking home as long as the weather <strong>is</strong> fine. (be)</p>
        <p>h. The bank will sanction you the loan provided you <strong>deposit </strong>a collateral. (deposit)</p>
        <p>i. What <strong>would you have done </strong> if you had not got his job? (you/do)</p>
        <p>j. If you had the choice, where <strong>would you live?</strong> (you/live)</p>
      </div>
      <hr/>
       <div>
        <p className='question'>C. Change the following sentences into 'if sentences' as in the example.</p>
        <br/>
        <p>Example: I did not go to a restaurant because I was not hungry.</p>
        <p>I would have gone to a restaurant if I had been hungry.</p>
        <br/>
        <p>a. The driver was talking on the phone so the accident happened.</p>
        <p>= The accident would not have happened if the driver had not been talking on the phone.</p>
        <br/>
        <p>b. There is no anyone at home because all the lights are off.</p>
        <p>= If the lights were on, there would be someone at home.</p>
        <br/>
        <p>c. He must be an educated person because he has subscribed 'The Kathmandu Post.'</p>
        <p>= He must be an educated person if he has subscribed to 'The Kathmandu Post.'</p>
        <br/>
        <p>d. His head was not injured in the accident because he had put the helmet on.</p>
        <p>= His head would have been injured in the accident if he had not put the helmet on.</p>
        <br/>
        <p>e. I am sure he is a doctor because he is wearing the white gown.</p>
        <p>= If he were not wearing the white gown, I would not be sure that he is a doctor.</p>
        <br/>
        <p>f. You didn't take any breakfast so you are hungry now.</p>
        <p>= You would not be hungry now if you had taken some breakfast.</p>
        <br/>
        <p>g. I am sure he is a doctor because he is wearing the white gown.</p>
        <p>= If he were not wearing the white gown, I would not be sure that he is a doctor.</p>
        <br/>
        <p>h. She is very rich so she drives a Mercedes.</p>
        <p>= If she were not very rich, she would not drive a Mercedes.</p>
        <br/>
        <p>i. I didn't know it was only half a kilometer from my house, so I booked a ride.</p>
        <p>= If I had known it was only half a kilometer from my house, I wouldn't have booked a ride.</p>
        <br/>
        <p>j. He has hidden something in his mind, so he does not look fresh.</p>
        <p>= If he had not hidden something in his mind, he would look fresh.</p>
       </div>
       
    </div>
  )
}

export default Careeropportunities
